export default {
  namespaced: true,
  state: {
    legendList: {}, // 图例的内容
  },
  getters: {
    legendList: state => state.legendList,
  },
  mutations: {
    SET_LEGEND_LIST(state, o) {
      state.legendList = o
    },
  },
  actions: {
  },
}
